// Right sidebar navigation component 
import { Component, EventEmitter, Input, Output } from '@angular/core';

// Using the same NavItem class from left sidebar
export class NavItem {
    public title: string = "";
    public icon: string = "";
    public Id?: string = "";
    public Count?: number = 0;
    public url: string = "";
    public Selected?: boolean = false;
    public roles?: string[] = [];
    public visible?: boolean = false;
}

@Component({
    selector: 'nav-right',
    templateUrl: './nav-right.component.html',
    styleUrls: ['./nav-right.component.scss'],
    standalone: false
})

export class NavRightComponent {
    // Input for expand state from parent component
    @Input() expandRight: boolean = false;
    
    // Output events to communicate with parent component
    @Output() setLayoutClassRight = new EventEmitter();
    @Output() reloadPage = new EventEmitter();
    @Output() showSearch: EventEmitter<boolean> = new EventEmitter();
    @Output() uploadModalRequested = new EventEmitter<void>();

    constructor() { }

    // generate report 
    public async ngOnInit() {
        // Initialize - no navigation setup needed for generate report functionality
    }

    //*************************************************************************
    //  Public Methods
    //*************************************************************************
    // Keep toggleMenu for expand/collapse functionality
    public toggleMenu(_collapse: boolean = false) {
        this.setLayoutClassRight.emit();
    }

    //Generate Excel Report
    public generateExcelReport() {
        // TODO: Replace stub with real report generation integration
        console.log('Generate Excel Report clicked');
    }
}
